<template>
  <vc-date-picker
    :key="calendarKey"
    :timezone="timezone"
    color="green"
    :is-dark="isDark"
    v-model="range"
    :columns="$screens({ default: 1, md: 2, lg: 2 })"
    mode="dateTime"
    is24hr
    is-range
  >
    <template v-slot="{ inputValue, togglePopover }">
      <v-text-field
        readonly
        label="Временной интервал"
        class="pointer"
        :value="`${inputValue.start} - ${inputValue.end}`"
        @click="togglePopover()"
      >
      </v-text-field>
      <div class="input_top">
        <v-chip-group class="children-chips" column>
          <!-- Периоды -->
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-chip
                small
                v-bind="attrs"
                v-on="on"
              > Выбрать период </v-chip>
            </template>
            <v-list dense>
              <v-list-item
                v-for="(item, index) in periods"
                :key="index"
                @click="setRange(item.period)"
              >
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <!-- Исключить даты -->
          <v-menu offset-y :close-on-content-click="false">
            <template v-slot:activator="{ on, attrs }">
              <v-chip
                small
                v-bind="attrs"
                v-on="on"
              > Исключить даты </v-chip>
            </template>

            <v-list dense style="max-height: 300px; overflow-y: auto;">
              <v-list-item
                v-for="(item, index) in pickedDates"
                :key="index"
                @click="selectExcludedDate(item.title)"
              >
                <v-list-item-title :style="{ color: excluded.includes(item.title) ? '#28A745' : '' }">{{ item.title }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

        </v-chip-group>
      </div>
    </template>
  </vc-date-picker>
</template>

<script>
import moment from 'moment'

export default {
  name: 'TimeIntervalWithExcludes',
  props: {
    value: {
      type: Object,
      required: true,
    },
    timezone: {
      type: String,
      default: 'Europe/Moscow',
    },
    default: {},
    excluded: {
      type: Array,
      default: () => ([])
    },
  },

  data() {
    return {
      calendarKey: 0,
      defaultDate: {
        start: moment().startOf('day').toDate(),
        end: moment().endOf('day').toDate(),
      },
      periods: [
        { period: 'today', title: 'Сегодня', selected: false },
        { period: 'yesterday', title: 'Вчера', selected: false },
        { period: 'week', title: 'Неделя', selected: true },
        { period: 'month', title: 'Месяц', selected: false },
        { period: 'current_month', title: 'Этот месяц', selected: false },
        { period: 'last_month', title: 'Предыдущий месяц', selected: false },
      ],
    }
  },

  computed: {
    range: {
      get() {
        if (Object.keys(this.value).length === 0) {
          this.$emit('input', this.defaultDate)
        }
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
    isDark() {
      return !!this.$vuetify.theme.dark
    },
    pickedDates() {
      if (!this.range.start) return []

      const dates = []
      const current = moment(this.range.start).startOf('day')
      const end = moment(this.range.end).startOf('day')

      while (current.isSameOrBefore(end, 'day')) {
        dates.push({title: current.format('YYYY-MM-DD'), selected: false})
        current.add(1, 'day')
      }

      return dates
    },
  },

  methods: {
    setRange(range) {
      let ranges = {
        today: {
          start: moment().startOf('day').toDate(),
          end: moment().endOf('day').toDate()
        },
        yesterday: {
          start: moment().subtract(1, 'day').startOf('day').toDate(),
          end: moment().subtract(1, 'day').endOf('day').toDate()
        },
        week: {
          start: moment().subtract(7, 'day').startOf('day').toDate(),
          end: moment().endOf('day').toDate()
        },
        month: {
          start: moment().subtract(1, 'month').startOf('day').toDate(),
          end: moment().endOf('day').toDate()
        },
        current_month: {
          start: moment().startOf('month').startOf('day').toDate(),
          end: moment().endOf('month').endOf('day').toDate()
        },
        last_month: {
          start: moment().subtract(1, 'month').startOf('month').startOf('day').toDate(),
          end: moment().subtract(1, 'month').endOf('month').endOf('day').toDate()
        },
      }

      this.range.start = ranges[range].start
      this.range.end = ranges[range].end
      this.excluded.length = 0

      this.calendarKey++
    },

    selectExcludedDate(day) {
      if (this.excluded.includes(day)) {
        const index = this.excluded.findIndex(item => item === day)
        this.excluded.splice(index, 1)
      } else {
        this.excluded.push(day)
      }
    },
  },

  mounted() {
    if (this.default) this.defaultDate = this.default
  },
}
</script>

<style scoped>
.input_top {
  position: relative;
  height: 4rem;
}

.input_top > .children-chips {
  /*left: 4.5rem;*/
  top: -1.5rem;
}

.pointer div input {
  cursor: pointer;
}
</style>
